export default __webpack_public_path__ + "static/media/no1dtraft-img.8a196042.svg";